"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _marginActions = require("./marginActions");
Object.keys(_marginActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _marginActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marginActions[key];
    }
  });
});
var _marginHistoryActions = require("./marginHistoryActions");
Object.keys(_marginHistoryActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _marginHistoryActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marginHistoryActions[key];
    }
  });
});
var _marginOrderActions = require("./marginOrderActions");
Object.keys(_marginOrderActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _marginOrderActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marginOrderActions[key];
    }
  });
});